export default {
  customers: state => state.customers,
  customersCounter: state => state.customersCounter,
  customerFilters: state => state.customerFilters,
  customer: state => state.customer,
  customerLogs: state => state.customerLogs,
  customerBookings: state => state.customerBookings,
  customerVisits: state => state.customerVisits,
  customerSipHistory: state => state.customerSipHistory,
}
